/* Add WOOOD reviewvoorwaarden link to Judge.me review form */
(function() {
  var translations = {
    nl: 'Bekijk hier de reviewvoorwaarden van WOOOD',
    en: 'View the WOOOD review terms here',
    de: 'Sehen Sie hier die Bewertungsbedingungen von WOOOD',
    fr: 'Consultez ici les conditions d\'avis de WOOOD'
  };

  function getLabel() {
    var lang = (document.documentElement.lang || 'nl').substring(0, 2).toLowerCase();
    return translations[lang] || translations['nl'];
  }

  function findPrivacyElement() {
    /* Try common Judge.me selectors */
    var selectors = [
      '.jdgm-form__privacy-policy',
      '.jdgm-form-privacy',
      '.jdgm-privacy',
      '[class*="jdgm"][class*="privacy"]',
      '[class*="jdgm"][class*="policy"]'
    ];
    for (var i = 0; i < selectors.length; i++) {
      var el = document.querySelector(selectors[i]);
      if (el) return el;
    }
    /* Fallback: find the element containing Judge.me terms links */
    var links = document.querySelectorAll('.jdgm-form a[href*="judge.me"]');
    if (links.length > 0) {
      return links[0].closest('div, p, span');
    }
    /* Last resort: find by the cancel/submit button area and go to its previous sibling */
    var cancelBtn = document.querySelector('.jdgm-form__cancel-btn, [class*="jdgm"][class*="cancel"]');
    if (cancelBtn) {
      var parent = cancelBtn.closest('div, form');
      if (parent) {
        var children = parent.children;
        for (var j = 0; j < children.length; j++) {
          if (children[j].textContent && children[j].textContent.indexOf('Judge.me') !== -1) {
            return children[j];
          }
        }
      }
    }
    return null;
  }

  function addReviewLink() {
    if (document.querySelector('.woood-review-terms')) return;
    var privacyEl = findPrivacyElement();
    if (privacyEl) {
      var link = document.createElement('p');
      link.className = 'woood-review-terms';
      link.style.marginTop = '8px';
      link.style.fontSize = 'inherit';
      link.style.textAlign = 'center';
      link.innerHTML = '<a href="/pages/reviewvoorwaarden" target="_blank" style="color:#000;text-decoration:underline;text-underline-offset:3px;">' + getLabel() + '</a>';
      privacyEl.insertAdjacentElement('afterend', link);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', addReviewLink);
  } else {
    addReviewLink();
  }

  var observer = new MutationObserver(function() {
    addReviewLink();
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();

/* B2B Application Form - Enhanced select styling + submission feedback */
(function() {
  function initB2BForm() {
    var form = document.getElementById('B2BApplicationForm');
    if (!form) return;

    /* Style select as "filled" when a real option is chosen */
    var selects = form.querySelectorAll('.b2b-form__select');
    selects.forEach(function(select) {
      select.addEventListener('change', function() {
        if (this.value) {
          this.style.color = '#000';
        } else {
          this.style.color = '#888';
        }
      });
    });

    /* Scroll to success/error message after form submission */
    var message = form.querySelector('.b2b-form__message');
    if (message) {
      message.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initB2BForm);
  } else {
    initB2BForm();
  }
})();
